/**
 * Returns true if params satisfy the "if" condition (properties match const or enum).
 */
export function ifConditionMatches(ifSchema, params) {
  const props = ifSchema?.properties
  if (!props) {
    return true
  }

  const propsMatch = Object.entries(props).every(([key, subSchema]) => {
    const value = params[key]
    if (subSchema.const !== undefined) {
      return value === subSchema.const
    }

    if (Array.isArray(subSchema.enum)) {
      return subSchema.enum.includes(value)
    }

    return value !== undefined
  })

  if (!propsMatch) {
    return false
  }

  const req = ifSchema.required || []
  return req.every(key => params[key] !== undefined)
}
